import React, { useState, useEffect } from "react";
import md5 from "md5";
import CryptoJS from "crypto-js";
import { TRAININGPART, EYE_SLASH_ICON, EYE_ICON, LOADING_SPIN_SMALL } from "../../assets/constants/Icons";
import { TYPE_SUCCESS, TYPE_INFO, INTERVAL, PHONE_NUMBER_PATTERN, emailPattern, PAN_NUMBER_PATTERN, CIN_NUMBER_PATTERN, GSTIN_NUMBER_PATTERN, TYPE_FAIL, passwordMatchPattern, SECRET_KEY } from "assets/constants/Constants";
import ShowToast from "components/ShowToast";
import { useLocation, useHistory } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import { fetchMetadata} from 'lib/utils';
import { createPartnerCall, updatePartnerCall, findUserByPartner, getUserList } from "lib/axiosUtils";

const CreatePartner = (props) => {
  const location = useLocation();
  const history = useHistory();
  const isPublic = !location.state;

  const { 
    partnerId, 
    representativeName: initialRepresentativeName = "", 
    representativeEmail: initialRepresentativeEmail = "", 
    representativeMobile: initialRepresentativePhone = "",
    trainingPartner: initialTrainingPartner = "", 
    addressLineOne: initialAddressLineOne = "", 
    addressLineTwo: initialAddressLineTwo = "", 
    pinCode: initialPinCode = "", 
    partnerBankName: initialPartnerBankName = "", 
    partnerBankAddress: initialPartnerBankAddress = "", 
    partnerList = [] 
  } = location.state || {};

  const [partnerName, setPartnerName] = useState(location.state?.partnerName ? { value: location.state.partnerName, label: location.state.partnerName } || "" : "");
  const [selectedPartnerNameOption, setPartnerNameSelectedOption] = useState(
    location.state?.partnerName ? { value: location.state.partnerName, label: location.state.partnerName } : ""
  );
  const [trainingPartner, setTrainingPartner] = useState(initialTrainingPartner);
  const [representativeName, setRepresentativeName] = useState(initialRepresentativeName);
  const [representativeEmail, setRepresentativeEmail] = useState(initialRepresentativeEmail);
  const [representativeMobile, setRepresentativePhone] = useState(initialRepresentativePhone);
  const [addressLineOne, setAddressLineOne]=useState(initialAddressLineOne);
  const [addressLineTwo, setAddressLineTwo]=useState(initialAddressLineTwo);
  const [pinCode, setPinCode] =useState(initialPinCode);
  const [state, setState] = useState(location.state ? (location.state.state ? location.state.state : null) : null);
  const [selectedStateOption, setStateSelectedOption] = useState(location.state ? (location.state.state ? { value: location.state.state_id, label: location.state.state } : "") : "");
  const [selectedCityOption, setCitySelectedOption] = useState(location.state ? { label: `${location.state.city_name}`, value: location.state.city_id } : null);
  const [city, setCity] = useState(location.state ? (location.state.city ? location.state.city : "") : "");
  const [disabled, setDisabled] = useState(location.state ? location.state.state ? false : true : true);
  const [error, setError] = useState({});
  const [metaData, setMetaData] = useState(isPublic ? [] : (JSON.parse(localStorage.getItem("metadata")) ? JSON.parse(localStorage.getItem("metadata")) : []));
  const[states,setStates] = useState(metaData.length > 0 ? metaData[0].meta_data.states: []);
  const[cities,setCities] = useState(metaData.length > 0 ? metaData[0].meta_data.cities: []);
  const [panCardNumber, setPanCardNumber] = useState(props.location.state ? props.location.state.panCardNumber ? props.location.state.panCardNumber :"" : "");
  const [cinNumber, setCinNumber] = useState(props.location.state ? props.location.state.cinNumber ? props.location.state.cinNumber :"" : "");
  const [gstinNumber, setGstinNumber] = useState(props.location.state ? props.location.state.gstinNumber ? props.location.state.gstinNumber :"" : "");
  const [invoiceName, setInvoiceName] =useState(props.location.state ? props.location.state.invoiceName ? props.location.state.invoiceName :"" : "")
  const [partnerBankName, setPartnerBankName] = useState(initialPartnerBankName);
  const [partnerBankAddress, setPartnerBankAddress] = useState(initialPartnerBankAddress);
  const [partnerAccountNumber, setPartnerAccountNumber] = useState(props.location.state ? props.location.state.partnerAccountNumber ? props.location.state.partnerAccountNumber :"" : "");
  const [programNames, setProgramName] = useState(metaData.length > 0 ? metaData[0].meta_data.program : []);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const userdetails = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    const fetchData = async () => {
      if (metaData && metaData.length === 0) {
        const metaResult = await fetchMetadata();
        setMetaData(metaResult)
        setStates(metaResult[0].meta_data.states);
        setCities(metaResult[0].meta_data.cities);
        setProgramName(metaResult[0].meta_data.program);
      }
    }
    fetchData();
  }, [metaData])

  useEffect(() => {
    const fetchPartnerLoginData = async () => {
      if (partnerId) {
        try {
          const partnerLoginData = await findUserByPartner({}, {}, partnerId);
          if (partnerLoginData && partnerLoginData.statusCode === 200) {
            const userData = partnerLoginData.data.result[0];
            setUserName(userData.username);
            setPassword(userData.password);
            setConfirmPassword(userData.password);
          }
        } catch (error) {
          console.error("Error fetching partner login data:", error);
        }
      }
    };

    fetchPartnerLoginData();
  }, [partnerId]);

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const userListData = await getUserList({}, {});
        if (userListData?.data?.result) {
          setUserList(userListData.data.result);
        }
      }
      catch (error) {
        console.log("Error occurred while fetching the user list", error);
      }
    }
    fetchUserList();
  }, []);
  

  useEffect((state) => {
  const setStatesListComponent = (states) => {
    let tempState = "";
    let stateName = "";
    if(props.location.state){
        stateName = props.location.state.state
      }
      const stateList = states.map((item) => {
        if (item.state_name === stateName) {
          tempState = { value: item.state_id, label: item.state_name };
        }
        return ({ value: item.state_id, label: item.state_name });
      })
      setStateSelectedOption(stateList);
      setState(tempState);
    }
    setStatesListComponent(states, state);
  }, [states, (props.location.state)]);

  const setCityListComponent = (cities) => {
    let tempCity = "";
    let cityName = "";
    if (props.location.state) {
      cityName = props.location.state.city;
    }
    const cityList = cities.map((item) => {
      if (item.city_name === cityName) {
        tempCity = { value: item.city_id, label: item.city_name };
      }
      return ({ value: item.city_id, label: item.city_name });
    })
    setCitySelectedOption(cityList);
    setCity(tempCity)
  }
  useEffect(() => {
    const setCityFromState = () => {
      let cityArray = cities.filter((item) => { return item.state_id === state.value });
      let cityName = "";
      let tempCity = "";
      if (props.location.state) {
        cityName = props.location.state.city;
      }
      let cityComponent = cityArray.map((item) => {
        if (item.city_name === cityName) {
          tempCity = { value: item.city_id, label: item.city_name };
        }
        return ({ label: item.city_name, value: item.city_id })
      })
      setCitySelectedOption(cityComponent);
      setCity(tempCity);
    }
    if (state) {
      setCityFromState();
    }
    else {
    }
  }, [state, cities, (props.location.state)]);

  useEffect(() => {
    const setProgramListComponent = (programNames) => {
      let tempProgram = "";
      let programsName = location.state?.partnerName || "";
      const programList = programNames.map((item) => {
        if (item === programsName) {
          tempProgram = { value: item, label: item };
        }
        return { value: item, label: item };
      });
      setPartnerNameSelectedOption(programList);

      if (!partnerName) {
        setPartnerName(tempProgram);
      }
    };

    setProgramListComponent(programNames);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programNames]);

  const createPartnerHandler = async (event) => {
    event.preventDefault();
    if (isFormValid()) {
      setLoading(true);
      const requestData = {
        partnerName: partnerName.label,
        trainingPartner:trainingPartner,
        representativeName: representativeName,
        representativePhoneNo: representativeMobile,
        representativeEmailId: representativeEmail,
        state: state?.label || "",
        city: city?.label || "",
        addressLineOne,
        addressLineTwo,
        pinCode,
        panCardNumber,
        invoiceName,
        cinNumber,
        gstinNumber,
        partnerBankName,
        partnerBankAddress,
        partnerAccountNumber,
        userName: userName ? userName : "",
        userPassword: password ? (partnerId == null ? md5(password) : password) : "",
        partnerId,
        displayPass: password ? CryptoJS.AES.encrypt(password, SECRET_KEY).toString() : "",
        userId: userdetails ? userdetails._id : null
      }

      let dataResponse = null;
      if (!partnerId) {
        dataResponse = await createPartnerCall({},requestData);
      } else {
        dataResponse = await updatePartnerCall({},requestData,partnerId);
      }

      if (dataResponse && dataResponse.statusCode === 200) {
        if (!partnerId) {
          if (dataResponse.data.message === "ExistedPartner") {
            const existedPartner = dataResponse.data.result.toString();
            ShowToast(`${existedPartner} already exist`, TYPE_INFO, INTERVAL, "", "");
            setLoading(false);
          } else {
            ShowToast('Please wait while Partner created', TYPE_INFO, INTERVAL, "");
            ShowToast('Partner created Successfully', TYPE_SUCCESS, INTERVAL, props, isPublic ? "/" : "/partner-page");
            setLoading(false);
          }
        } else {
          ShowToast('Please wait while Partner updated', TYPE_INFO, INTERVAL, "");
          setLoading(false);
          ShowToast('Partner updated Successfully', TYPE_SUCCESS, INTERVAL, props, "/partner-page");
        }
      }
    }
    else {
      ShowToast('Please enter required data', TYPE_FAIL, INTERVAL, null, "");
    }
  }

  const cancelHandler = () => {
    history.push(isPublic ? "/" : "/partner-page");
  }

  const isFormValid = () => {
    let isValid = true;
    let error = {};

    if (!partnerName) {
      isValid = false;
      error.partnerNameError = "Please select Program name";
    }
    if (!trainingPartner) {
      isValid = false;
      error.trainingPartnerError = "Please enter Training partner";
    }
    if (!representativeName) {
      isValid = false;
      error.representativeNameError = "Please enter representative name";
    }
    if(!state) {
      isValid = false;
      error.state = "Please select state";
    }
    if(!city) {
      isValid = false;
      error.city = "Please select city";
    }

    if (representativeEmail) {
      if (!emailPattern.test(representativeEmail)) {
        isValid = false;
        error.representativeEmailIdError = "Please enter a valid email address.";
      }
      else {
        if (!partnerId) {
          const findUser = userList.find((findItem) => findItem.email_id.trim().toLowerCase() === representativeEmail.trim().toLowerCase());
          if (findUser) {
            isValid = false;
            error.representativeEmailIdError = "Email Id already present, please try with different email id!";
          }
        }
      }
    } else {
      isValid = false;
      error.representativeEmailIdError = "Please enter an email address";
    }

    if (representativeMobile) {
      if (!PHONE_NUMBER_PATTERN.test(representativeMobile)) {
        isValid = false;
        error.representativePhoneError = "Please enter a valid mobile number.";
      }
    } else {
      isValid = false;
      error.representativePhoneError = "Please enter a mobile number";
    }
    if (pinCode) {
      const tempPin = pinCode;
      if (tempPin.toString().length !== 6) {
        isValid = false;
        error.pinCodeError = "Please enter a valid Pin Code number";
      }
    } else {
      isValid = false;
      error.pinCodeError = "Please enter Pin Code number";
    }
    if (panCardNumber !== "") {
      if (!PAN_NUMBER_PATTERN.test(panCardNumber)) {
        isValid = false;
        error.panCardNumberError = "Please enter a valid PAN number";
      }
    }
    if (cinNumber !== "") {
      if (!CIN_NUMBER_PATTERN.test(cinNumber)) {
        isValid = false;
        error.cinError = "Please enter a valid CIN number";
      }
    }
    if (gstinNumber !== "") {
      if (!GSTIN_NUMBER_PATTERN.test(gstinNumber)) {
        isValid = false;
        error.gstinError = "Please enter a valid GSTIN number";
      }
    }
    if (userName && !partnerId) {
      const findUser = userList.find((findItem) => findItem.username.trim().toLowerCase() === userName.trim().toLowerCase());
      if (findUser) {
        isValid = false;
        error.userName = "Please enter different username";
      }
    }
    if (password) {
      if (partnerId == null) {
        if (!passwordMatchPattern.test(password)) {
          isValid = false;
          error.password = "Please enter valid password";
          ShowToast('Password must be minimum eight characters including one uppercase letter,\n one special character and alphanumeric characters', TYPE_INFO, INTERVAL, props, "");
        }
      }
    }
    if (password !== confirmPassword) {
      isValid = false;
      error.confirmPassword = "Entered password and confirm password does not match";
    }

    setError(error);
    return isValid;
  };

  const handleStateChange = (selected) => {
    let selectedCites = metaData[0].meta_data.cities.filter((item) => {
        return selected.value === item.state_id
    });
    setCityListComponent(selectedCites);
    setDisabled(false);
    setState(selected);
};

const handleCityChange = (selected) => {
    setCity(selected);
};

  const handlePartnerNameChange = (selected) => {
    setPartnerName(selected);
  };

const setAccountNumber = (event) => {
  const regularExpression = /^[0-9\b]+$/;
  if (event.target.value === '' || regularExpression.test(event.target.value)) {
      setPartnerAccountNumber(event.target.value);
  }
}

const handlePartnerRepresentativeNumberChange = (event) => {
  if (!isNaN(event.target.value)) {
      setRepresentativePhone(event.target.value) 
  }
}

const handlePinCodeChange = (event) => {
  if (!isNaN(event.target.value) && event.target.value.length < 7) {
      setPinCode(event.target.value);
  }
}

const handlePanNumberChange = (event) => {
  if (event.target.value.length < 11) {
      setPanCardNumber(event.target.value)
  }
}
const handleGstinNumberChange = (event) => {
  if (event.target.value.length < 16) {
      setGstinNumber(event.target.value)
  }
}

const handleCinNumberChange = (event) => {
  if (event.target.value.length < 22) {
      setCinNumber(event.target.value)
  }
}

const isValidTrainingPartner = (event) => {
  const trimValue = event.target.value.trim();
  if (partnerList && partnerList.length > 0) {
    const duplicatePartnerFound = partnerList.find((findItem) => findItem.training_partner.trim() === trimValue);
    if (duplicatePartnerFound) {
      if (partnerId) {
        if (duplicatePartnerFound._id !== partnerId) {
          ShowToast("Same training partner '" + trimValue + "' is already present. Please enter different training partner", TYPE_FAIL, INTERVAL, "", "");
          setTrainingPartner("");
        }
      }
      else {
        ShowToast("Same training partner '" + trimValue + "' is already present. Please enter different training partner", TYPE_FAIL, INTERVAL, "", "");
        setTrainingPartner("");
      }
    }
  }
}

const usernameUniqueHandler = (event) => {
  if (event.target.value) {
    if (!partnerId) {
      const userFound = userList.find((findItem) => findItem.username.trim().toLowerCase() === event.target.value.trim().toLowerCase())
      if (userFound) {
        ShowToast(`Username "${event.target.value}" already present, please try with different username!`, TYPE_FAIL, INTERVAL, "", "");
        setUserName("");
      }
    }
  }
}

const emailUniqueHandler = (event) =>{
  if(event.target.value){
    if (!partnerId) {
      const userFound = userList.find((findItem) => findItem.email_id.trim().toLowerCase() === event.target.value.trim().toLowerCase())
      if(userFound){
        ShowToast('Email Id already present, please try with different email id!', TYPE_FAIL, INTERVAL, "", "");
        setRepresentativeEmail("")
      }
    }
  }
}

const handleShowPasswordClick = () => {
  if (partnerId == null) {
    setShowPassword(!showPassword);
  }
}

const handleShowConfirmPasswordClick = () =>{
  setShowConfirmPassword(!showConfirmPassword);  
}

  return (
    <>
      <div className="main-content">
        <div className="back">
          <ul className="breadcrumb1"></ul>
        </div>
        <div className="add-meter-main-view">
          <div className="mx-auto text-left border create-meter-div">
            <form className="pt-1" autoComplete="off">
              <div className="meter-icon-wrapper">
                <h4>{partnerId === null ? "Add New Partner" : (partnerId ? "Edit Partner" : "Add New Partner")}</h4>
                <i className={`${TRAININGPART} list-table-icon`}></i>
              </div>

              <div className="row">
                <div className="input-label-group col-md-6">
                  <label className="form-label">Program Name<span className="text-danger">*</span></label>
                  <CreatableSelect
                    placeholder={`Select Program Name`}
                    name="unitStatus"
                    value={partnerName}
                    onChange={handlePartnerNameChange}
                    options={selectedPartnerNameOption}
                  />
                  <div className="text-danger error-msg">
                    {error.partnerNameError}
                  </div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Training Partner<span className="text-danger">*</span></label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={trainingPartner} onChange={(e) => { setTrainingPartner(e.target.value) }} placeholder="Enter Training Partner " onBlur={(e) => isValidTrainingPartner(e)} />
                  <div className="text-danger error-msg">{error.trainingPartnerError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Representative Name <span className="text-danger">*</span></label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={representativeName} onChange={(e) => { setRepresentativeName(e.target.value) }} placeholder="Enter Name" />
                  <div className="text-danger error-msg">{error.representativeNameError}</div>
                </div>
                <div className="input-label-group col-md-6 email-input">
                  <label className="form-label">Representative Email <span className="text-danger">*</span></label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input email-lowercase" value={representativeEmail} onChange={(e) => { setRepresentativeEmail(e.target.value) }} onBlur={emailUniqueHandler} placeholder="Enter Email" />
                  <div className="text-danger error-msg">{error.representativeEmailIdError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Representative Mobile <span className="text-danger">*</span></label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={representativeMobile} onChange={(e) => { handlePartnerRepresentativeNumberChange(e) }} placeholder="Enter Contact No." />
                  <div className="text-danger error-msg">{error.representativePhoneError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">State <span className="text-danger">*</span></label>
                  <Select
                    placeholder={`Select State`}
                    name="state"
                    value={state}
                    onChange={handleStateChange}
                    options={selectedStateOption}
                  />
                  <div className="text-danger error-msg">
                    {error.state}
                  </div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">City <span className="text-danger">*</span></label>
                  <Select
                    placeholder={`Select City`}
                    name="city"
                    value={city}
                    options={selectedCityOption}
                    onChange={handleCityChange}
                    isDisabled={disabled}
                  />
                  <div className="text-danger error-msg">
                    {error.city}
                  </div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">PIN Code <span className="text-danger">*</span></label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={pinCode} onChange={(e) => { handlePinCodeChange(e) }} placeholder=" Enter PIN Code" />
                  <div className="text-danger error-msg">{error.pinCodeError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Address Line 1</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={addressLineOne} onChange={(e) => { setAddressLineOne(e.target.value) }} placeholder=" Enter Your Address" />
                  <div className="text-danger error-msg">{error.addressLineOne}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Address Line 2</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={addressLineTwo} onChange={(e) => { setAddressLineTwo(e.target.value) }} placeholder=" Enter Your Address" />
                  <div className="text-danger error-msg">{error.addressLineTwo}</div>
                </div>
                <div className="bank-details-div">
                    <label className="bank-detail-label">Please input the below details to ensure a smooth process for The Job Plus and finance through the project </label>
                    <div className="section-div"></div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Billing Entity Name</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={invoiceName} onChange={(e) => { setInvoiceName(e.target.value) }} placeholder=" Enter Billing Entity Name" />
                  <div className="text-danger error-msg">{error.invoiceError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">CIN Number</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input text-transform-uppercase" value={cinNumber} onChange={(e) => { handleCinNumberChange(e) }} placeholder=" Enter CIN Number" />
                  <div className="text-danger error-msg">{error.cinError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">GSTIN Number</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input text-transform-uppercase" value={gstinNumber} onChange={(e) => { handleGstinNumberChange(e) }} placeholder=" Enter GSTIN Number" />
                  <div className="text-danger error-msg">{error.gstinError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">PAN Card Number</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input text-transform-uppercase" value={panCardNumber} onChange={(e) => { handlePanNumberChange(e) }} placeholder=" Enter PAN Card Number" />
                  <div className="text-danger error-msg">{error.panCardNumberError}</div>
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Partner Account Number</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={partnerAccountNumber} onChange={(e) => { setAccountNumber(e) }} placeholder=" Enter Partner Account Number" />
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Partner Bank Name</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={partnerBankName} onChange={(e) => { setPartnerBankName(e.target.value) }} placeholder=" Enter Partner Bank Name" />
                </div>
                <div className="input-label-group col-md-6">
                  <label className="form-label">Partner Bank Address</label>
                  <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={partnerBankAddress} onChange={(e) => { setPartnerBankAddress(e.target.value) }} placeholder=" Enter Partner Bank Address" />
                </div>
              </div>
              {
                (partnerId !== null && password && userName) || partnerId === null ? (<>
                  <div className="user-creation mt-4">
                    <label className="bank-detail-label">Create user login credentials</label>
                    <div className="section-div"></div>
                  </div>
                  <div className="row">
                    <div className="input-label-group col-md-6 email-input">
                      <label className="form-label">User Name</label>
                      <input type="text" name="username" style={{ display: 'none' }} />
                      <input className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={userName} onChange={(e) => { setUserName(e.target.value) }} onBlur={usernameUniqueHandler} placeholder="Enter User Name" autoComplete="off" name="partner_real_user_987" disabled={partnerId ? true : false} />
                      <div className="text-danger error-msg">
                        {error.userName}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-label-group col-md-6">
                      <label className="form-label">Password</label>
                      <div className="password-input-div">
                        {
                          showPassword ? (<>
                            <input type="text" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={password} onChange={(e) => { setPassword(e.target.value) }} placeholder="Enter Password" disabled={partnerId ? true : false} name="partner_real_pass_654" autoComplete="off" />
                            <i className={`${EYE_SLASH_ICON} eye-icon-class-for-password`} onClick={handleShowPasswordClick} title="View password"></i>
                          </>) : (<>
                            <input type="password" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={password} onChange={(e) => { setPassword(e.target.value) }} placeholder="Enter Password" disabled={partnerId ? true : false} name="partner_real_pass_64" autoComplete="off" />
                            <i className={`${EYE_ICON} eye-icon-class-for-password`} onClick={handleShowPasswordClick} title="View password"></i>
                          </>)
                        }
                      </div>
                      <div className="text-danger error-msg">
                        {error.password}
                      </div>
                    </div>
                    <div className="input-label-group col-md-6">
                      <label className="form-label">Confirm Password</label>
                      <div className="password-input-div">
                        {
                          showConfirmPassword === true ? (<>
                            <input type="text" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} placeholder="Confirm Password" disabled={partnerId ? true : false} name="partner_confirm_pass_654" autoComplete="off" />
                            <i className={`${EYE_SLASH_ICON} eye-icon-class-for-password`} onClick={handleShowConfirmPasswordClick} title="View Password"></i>
                          </>) : (<>
                            <input type="password" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} placeholder="Confirm Password" disabled={partnerId ? true : false} name="partner_confirm_pass_54" autoComplete="off" />
                            <i className={`${EYE_ICON} eye-icon-class-for-password`} onClick={handleShowConfirmPasswordClick} title="View Password"></i>
                          </>)
                        }
                      </div>
                      <div className="text-danger error-msg">
                        {error.confirmPassword}
                      </div>
                    </div>
                  </div>
                </>) :(<></>)
              }
              <div className="row mt-4 mb-5">
                <div className="form-button-div">
                  {
                    loading ? (
                      <i className={`${LOADING_SPIN_SMALL}`}></i>
                    ) : (
                      <button className="brand-button" onClick={createPartnerHandler}>Submit</button>
                    )
                  }
                  <button className="cancel_button ml-5" onClick={cancelHandler}>Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreatePartner;